// extracted by mini-css-extract-plugin
module.exports = {"container":"_02712f2b3b--container--uvabR","block":"_02712f2b3b--block--T0agF","block--opened":"_02712f2b3b--block--opened--V_znt","button":"_02712f2b3b--button--RUyxR"};